export const CurrentStudents = [
  {
    name: "Jennifer Sanchez",
    title: "PhD Student",
    description: "Jennifer is a PhD student at the University of Texas at San Antonio studying physical chemistry. She received her bachelor's degree and master’s degree from the University of Texas Rio Grande Valley studying theoretical chemistry regarding organometallic catalysts. Jennifer joined the Xu lab in Fall 2022 and is currently working on several projects pertaining to hydrogen storage materials and single-atom catalysts.",
    email: "jennifer.sanchez@utsa.edu",
    avatar: "/people/sanchez-jennifer.jpg"
  },
  {
    name: "Bishal Gautam",
    title: "PhD Student",
    description: "Bishal is a PhD student who joined the Xu Lab in January 2024. He completed his Master's degree in Organic Chemistry and Bachelor's degree in Chemistry, both from Tribhuvan University in Nepal. He also worked as a research assistant for a year in Nepal Academy of Science and Technology located in Lalitpur, Nepal. He works on the project of single atom platinum catalysts on transition metals carbides.",
    email: undefined,
    avatar: "/people/bishal-gautam.jpg"
  },
  {
    name: "Dahee Lee",
    title: "PhD Student",
    description: "Dahee is a PhD student at the University of Texas at San Antonio studying physical chemistry. She received her bachelor’s degree in chemistry from the University of Texas at San Antonio. Dahee joined the Xu lab in Summer 2021 as an undergraduate. She is currently working on probing the CISS effect in chiral molecules using UHV-STM.",
    email: undefined,
    avatar: "/people/lee-dahee.jpg"
  },
  {
    name: "Rafael Flores",
    title: "PhD Student",
    description: "Rafael is a Ph.D. student in physical chemistry at the University of Texas at San Antonio. He earned his Bachelor of Science in Chemistry from Saint Edward’s University in Austin, Texas, where he was involved in biomimetic modeling of metalloenzymes implicated in central nervous system (CNS) diseases. In October 2021, Rafael joined a synthetic laboratory at the University of the Incarnate Word’s Feik School of Pharmacy as a Medicinal Chemistry Research Associate. He joined the Xu Lab in Fall 2025 and is currently interested in investigating the reactivity of porphyrin based single-atom catalysts using ultra-high vacuum scanning tunneling microscopy (UHV-STM).",
    email: undefined,
    avatar: "/people/rafael-flores.jpg"
  },
  {
    name: "Aadhya Bobbala",
    title: "High School Student",
    description: "Aadhya Bobbala is a junior at Keystone School in San Antonio, Texas. She joined Dr. Xu’s lab in the summer of 2025 and is planning to study chemistry and environmental engineering in undergrad.",
    email: undefined,
    avatar: "/people/Aadhya-bobbala.jpg"
  },
  {
    name: "Anastasiia Gordeeva",
    title: "Undergraduate Student",
    description: "Anastasiia is an undergraduate student majoring in Chemistry with a minor in Neuroscience at the University of Texas at San Antonio. She joined Dr. Xu's lab in Spring 2025 to work on the CISS project using scanning tunneling microscopy. Her previous research experience includes mass spectrometry. She plans to pursue a PhD in Chemistry.",
    email: "anastasiia.gordeeva@utsa.edu",
    avatar: "/people/Anastasiia Gordeeva.jpg"
  },
  {
    name: "Isaac Moreno",
    title: "Undergraduate Student",
    description: "Isaac is an undergraduate student from UTSA. He conducts an independent study in Xu lab in spring 2026 and works on the powder catalysis projects.",
    email: undefined,
    avatar: "/people/isaac-moreno.jpg"
  },
  {
    name: "Alexander Bachtold Ricoy",
    title: "Undergraduate Student",
    description: "Alexander is an undergraduate student majoring in Mechanical Engineering at the University of Texas at San Antonio. He joined the Xu Lab in fall 2026 as a research volunteer working on the boron project. Upon graduating, he plans on pursuing an M.S. at TU Darmstadt, in Germany.",
    email: undefined,
    avatar: "/people/Alexander Bachtold Ricoy.jpg"
  },
];

export const formerStudents = [
  {
    name: "Kevin Sutherland (2026')",
    title: "Ph.D. Student",
    description: "Kevin studied in Xu lab from 2021-2026. He then started a postdoc position at UC Merced under supervision of Prof. Mehmet Baykara.",
    avatar: "/people/sutherland-kevin.jpg"
  },
  {
    name: "Thomas Garcia (2027')",
    title: "Master's Student",
    description: "Thomas studied in Xu lab in 2025 prior to join the research lab mentored by Prof. Charles Markus after the research lab renovation completes.",
    avatar: "/people/thomas-garcia.jpg"
  },
  {
    name: "Bernice Adeeso (2023')",
    title: "Master's Student",
    description: "Bernice studied in Xu lab from 2021-2023. She then started a career in industry.",
    avatar: "/people/adeeso-bernice.jpg"
  },
  {
    name: "Cindy Bair (2023')",
    title: "Undergraduate Student",
    description: "Cindy studied in Dr. Xu’s lab in from summer 2022 to spring 2023. After graduation, she continued her study at UTSA towards a M.S. degree.",
    avatar: "/people/bair-cindy.jpg"
  },
  {
    name: "Luis Hernandez (2022')",
    title: "Undergraduate Student",
    description: "Luis joined the Xu lab in Summer 2022 for an independent study. After graduation, he started a career at Viatris.",
    avatar: "/people/hernandez-luis.jpg"
  },
  {
    name: "Nathan McLane (2021')",
    title: "Undergraduate Student",
    description: "Nathan joined Dr. Xu’s lab in Summer 2021 and continued the work to 2022. In the same year, Nathan was accepted to a Ph.D. in chemistry program at University of Maryland at College Park.",
    avatar: "/people/mclane-nathan.jpg"
  },
  {
    name: "Reese Roddy (2023')",
    title: "Undergraduate Student",
    description: "Reese is an undergraduate student at the University of Texas at San Antonio majoring in mechanical engineering. He studied in Dr. Xu’s lab from Summer 2021 to 2023. After graduation, Reese started his career in Southwest Research Institute",
    avatar: "/people/roddy-resse.jpg"
  },
  {
    name: "John Leija (2025')",
    title: "Undergraduate Student",
    description: "John is an undergraduate student majoring in mechanical engineering at the University of Texas at San Antonio. He produced CAD designs and developed lab hardware from the fall of 2023 to the spring of 2025. John was accepted to the Ph.D. in Mechanical Engineering at UTSA.",
    email: undefined,
    avatar: "/people/john-leija.jpg"
  },
  {
    name: "Adam Buratowski (2025')",
    title: "Undergraduate Student",
    description: "Adam is an undergraduate student majoring in chemistry at the University of Texas at San Antonio. He studied in Dr. Xu’s lab from spring 2024 to spring 2025. Adam was accepted to the Ph.D. in chemistry program at University of Virginia.",
    email: undefined,
    avatar: "/people/adam-buratowski.jpg"
  },
  {
    name: "Ryan Huddleston",
    title: "Undergraduate Student",
    description: "Ryan is an undergraduate student, majoring in Biochemistry at the University of Texas at San Antonio. He studied in Dr. Xu's lab in spring of 2025 and transfer to another university afterwards.",
    email: undefined,
    avatar: "/people/ryan-huddleston.jpg"
  },
  {
    name: "Austin Herrod (2027')",
    title: "Undergraduate Student",
    description: "Austin is an undergraduate student at the University of Texas at San Antonio majoring in mechanical engineering. He worked in Xu lab in the spring of 2024 on a project to develop a heating frame for STREAM SPM system.",
    email: undefined,
    avatar: "/people/austin-herrod.jpg"
  },
];